// 默认配置
module.exports = {
    // SDK下载链接
    DOWNLOAD_CONFIG: [
        {
            id: 0,
            name: "Android",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_Android.zip",
        },
        {
            id: 1,
            name: "iOS",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_iOS.zip",
        },
        {
            id: 2,
            name: "Win32",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_Win32_mt.zip",
        },
        {
            id: 3,
            name: "UE4",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_UE4.zip",
        },
        {
            id: 4,
            name: "Unity",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_Unity3D.zip",
        },
        {
            id: 5,
            name: "Cocos",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_Cocos.zip",
        },
        {
            id: 6,
            name: "Win64",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_Win64_mt.zip",
        },
        {
            id: 7,
            name: "Wwise",
            url: "https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/GVoice-Ex/SDK/gcloud_voice_3_1_0_149472631_20210511_400_Wwise.zip",
        },
    ],
    // SDK下载页更新说明
    UPDATE_CONFIG: {
        version: "2.0.8",
        date: "2021.07.15",
        desc: ["[优化] 网络传输优化，抗丢包能力提升一倍;", "[更新] ostream句柄泄露crash fix;", "[更新] 支持声纹增强（默认关闭）"],
    },
};
